import { Form, FormProps } from 'antd';
import classNames from 'classnames';
import { Formik } from 'formik';
import { useMemo } from 'react';
import Icon from '../../icons';
import { CustomModalProps } from '../../interfaces';
import '../../styles.scss';
import CustomButton from '../Button';
import { GoBackButton, HorizontalModal, VerticalModal } from './styles';
import './styles.scss';
import { useTranslation } from 'react-i18next';

export { default as InformativeModal } from './InformativeModal';

const defaultFormProps: FormProps & {
  id: string;
} = {
  layout: 'vertical',
  id: 'modal-id',
};

const CustomModal: React.FC<CustomModalProps> = props => {
  const {
    goBack,
    children,
    onCancel,
    className,
    width = 488,
    footerBorder,
    unsetBodyPadding,
    title = 'Modal',
    footer: _footer,
    fullPaddingFooter,
    layout = 'horizontal',
    destroyOnClose = true,
    centerContent = false,
    hideCloseButton = false,
    formProps: _formProps = defaultFormProps,
    formikProps,
    closeIcon,
    ...rest
  } = props;
  const { t } = useTranslation();
  const formProps = { ...defaultFormProps, ..._formProps };
  const { id } = formProps;

  const Wrapper = layout === 'horizontal' ? HorizontalModal : VerticalModal;

  const footer = useMemo(() => {
    return (
      _footer ?? [
        <CustomButton
          key="cancel-btn"
          width="100%"
          size="large"
          type="white"
          onClick={e => {
            onCancel?.(e as any);
          }}
        >
          {t('common.cancel')}
        </CustomButton>,
        <CustomButton
          key="submit-btn"
          width="100%"
          htmlType="submit"
          size="large"
          form={id}
        >
          {t('common.submit')}
        </CustomButton>,
      ]
    );
  }, [_footer, onCancel, id, t]);

  return (
    <Wrapper
      {...rest}
      width={width}
      className={classNames(className, {
        'no-close-btn': hideCloseButton,
        'no-footer': _footer === null,
        'no-padding-body': unsetBodyPadding,
        'full-padding-footer': fullPaddingFooter,
        'footer-border': footerBorder,
        'center-content': centerContent,
      })}
      title={
        <>
          {!!goBack && (
            <GoBackButton type="text" className="prev-btn" onClick={goBack}>
              <Icon name="arrowLeft" />
            </GoBackButton>
          )}
          {title}
        </>
      }
      footer={_footer !== null ? footer : null}
      onCancel={onCancel}
      destroyOnClose={destroyOnClose}
      closeIcon={closeIcon ? closeIcon : <Icon name="close" />}
    >
      {formikProps ? (
        <Formik {...formikProps}>
          {({ handleSubmit }) => {
            return (
              <Form {...formProps} id={id} onFinish={handleSubmit}>
                {children}
              </Form>
            );
          }}
        </Formik>
      ) : (
        children
      )}
    </Wrapper>
  );
};

export default CustomModal;
